import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getBoolFromBitValue } from '../../../common/utils/helpers';
import { Logger } from '../../../common/utils/logger';
import { ATLASSIAN_CONSENT_COOKIE_KEY, ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY, ATLASSIAN_SHOW_BANNER_COOKIE_KEY } from '../../../constants';
import { getValidConsentData } from '../../cookie-controls/get-consent-token/utils';
import { getCookie } from '../../cookie-controls/get-cookie';
import { setRequiredConsentCookies } from '../../cookie-controls/set-required-consent-cookies';
import { checkTokenVersionValidity } from '../../cookie-controls/transformer';

/**
  Asynchronously fetches data from ConsentHub (or uses cached cookies from the client) to determine banner visibility.
  Useful for: consumers who want to avoid adding the banner to their bundled code, if it should be hidden to begin with
*/
export var shouldRenderBanner = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var fallbackConsentToken, consentToken, cachedShouldShowBanner, noCachedCookies, validCachedConsentToken, consentData, shouldShowBanner;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fallbackConsentToken = getCookie(ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY);
          consentToken = getCookie(ATLASSIAN_CONSENT_COOKIE_KEY) || '';
          cachedShouldShowBanner = getBoolFromBitValue(getCookie(ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
          if (!cachedShouldShowBanner) {
            _context.next = 6;
            break;
          }
          Logger.debug("shouldRenderBanner: Rendering banner becaue of show banner cookie ".concat(ATLASSIAN_SHOW_BANNER_COOKIE_KEY));

          /* Once consents are made in a live environment, this function will return false 98% of the time
              making it nearly impossible to test. This check gives us the capability to force showing the banner for testing.
              ... However, we are introducing a potential discrepancy issue in the future for some adopters where this
              cache bit check may be out of sync/inaccurate, but we're okay with that for now. */
          return _context.abrupt("return", true);
        case 6:
          noCachedCookies = !consentToken;
          validCachedConsentToken = checkTokenVersionValidity(consentToken).isValid;
          if (!noCachedCookies) {
            _context.next = 14;
            break;
          }
          _context.next = 11;
          return getValidConsentData(fallbackConsentToken);
        case 11:
          _context.t0 = _context.sent;
          _context.next = 15;
          break;
        case 14:
          _context.t0 = {
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken
          };
        case 15:
          consentData = _context.t0;
          if (!(!consentData || !noCachedCookies && !validCachedConsentToken)) {
            _context.next = 19;
            break;
          }
          Logger.debug('shouldRenderBanner: Rendered banner because no consent data found');
          // No consent data: the token value we fetched was deemed invalid for some reason, show the banner for compliance
          return _context.abrupt("return", true);
        case 19:
          setRequiredConsentCookies(consentData.consentToken, consentData.consentTimestamp);
          shouldShowBanner = getBoolFromBitValue(getCookie(ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
          Logger.debug("shouldShowBanner: render computed based on ATLASSIAN_SHOW_BANNER_COOKIE_KEY after setting consents: ".concat(shouldShowBanner));
          return _context.abrupt("return", !!shouldShowBanner);
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function shouldRenderBanner() {
    return _ref.apply(this, arguments);
  };
}();